export default function onClick(e) {
  var swiper = this;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/events/onClick.js
// module id = 714
// module chunks = 169